export const YOUTUBE_EMBED_URL_PATTERN =
  /^https?:\/\/(www\.)?youtube\.com\/embed\/[A-Za-z0-9_-]{11}(?:\?.*)?$/;

export const extractYouTubeVideoId = (url) => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  const trimmedUrl = url.trim();

  // Direct embed url.
  {
    const match = trimmedUrl.match(
      /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([A-Za-z0-9_-]{11})(?:\?.*)?$/
    );
    if (match?.[1]) {
      return match[1];
    }
  }

  const patterns = [
    // https://www.youtube.com/watch?v=VIDEO_ID&other_params
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([A-Za-z0-9_-]{11})/,
    // https://m.youtube.com/watch?v=VIDEO_ID
    /(?:https?:\/\/)?m\.youtube\.com\/watch\?.*v=([A-Za-z0-9_-]{11})/,
    // https://youtube.com/watch?v=VIDEO_ID (без www)
    /(?:https?:\/\/)?youtube\.com\/watch\?.*v=([A-Za-z0-9_-]{11})/,
    // https://youtu.be/VIDEO_ID
    /(?:https?:\/\/)?youtu\.be\/([A-Za-z0-9_-]{11})/,
    // https://www.youtube.com/shorts/VIDEO_ID
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})(?:[/?#].*)?$/,
    // https://youtube.com/shorts/VIDEO_ID (без www)
    /(?:https?:\/\/)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})(?:[/?#].*)?$/,
  ];

  for (const pattern of patterns) {
    const match = trimmedUrl.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }

  return null;
};

export const convertToYouTubeEmbed = (url) => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const trimmedUrl = url.trim();

  if (YOUTUBE_EMBED_URL_PATTERN.test(trimmedUrl)) {
    return trimmedUrl;
  }

  const videoId = extractYouTubeVideoId(trimmedUrl);
  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}`;
  }

  return trimmedUrl;
};

